import {
  GET_FUNDS_LIST_PAN_SUCCESS,
  GET_TRANSACTION_HISTORY_SUCCESS,
  GET_NAV_DATA_SUCCESS,
  REMOVE_NAV_DATA,
  REMOVE_TRANSACTION_HISTORY_DATA
} from "../types";

const initialState = {
  fundsList: [],
  transactions: [],
  navData: []
};

export function transactionHistory(state = initialState, action) {
  switch (action.type) {
    case GET_FUNDS_LIST_PAN_SUCCESS: {
      const { Table1: fundsList } = action.body;
      return { ...state, fundsList };
    }
    case GET_TRANSACTION_HISTORY_SUCCESS: {
      const { Table1: transactions } = action.body;
      return { ...state, transactions };
    }
    case GET_NAV_DATA_SUCCESS: {
      const { Table1: navData } = action.body;
      return { ...state, navData };
    }
    case REMOVE_NAV_DATA: {
      return { ...state, navData: [] };
    }
    case REMOVE_TRANSACTION_HISTORY_DATA :{
      return {...state,transactions:[]}
    }
    default:
      return state;
  }
}
